import sprite from "./sprite";

export default function ($container = $(document)) {
    $container.find(`[data-tabs-button]`).on('click', function () {
        const $this = $(this);
        const ns = $this.data('tabs-ns');
        const key = $this.data('tabs-button');

        const $buttons = $container.find(`[data-tabs-ns="${ns}"][data-tabs-button]`);
        const $blocks = $container.find(`[data-tabs-ns="${ns}"][data-tabs-block]`);

        const $buttonsOther = $buttons.filter(`:not([data-tabs-button="${key}"])`);
        const $blocksOther = $blocks.filter(`:not([data-tabs-block="${key}"])`);
        const $buttonsCurrent = $buttons.filter(`[data-tabs-button="${key}"]`);
        const $blocksCurrent = $blocks.filter(`[data-tabs-block="${key}"]`);

        $buttonsOther.removeClass('is-active');
        $blocksOther.removeClass('is-active');
        $buttonsCurrent.addClass('is-active');
        $blocksCurrent.addClass('is-active');

        $buttonsOther.trigger('tabs-off');
        $buttonsCurrent.trigger('tabs-on');

        if ($blocksCurrent.find('.js-animation')) {
            $blocksCurrent.find('.js-animation').show('slow')
            setTimeout(function () {
                $blocksCurrent.find('.js-animation').hide('slow');
            }, 4000);
        }
        if ($blocksCurrent.find('.js-content')) {
            setTimeout(function () {
                $blocksCurrent.find('.js-content').show('slow');
            }, 4000);
        }
    });
    $container.find(`[data-hover-button]`).on('mouseenter', function () {
        const $this = $(this);
        const ns = $this.data('hover-ns');
        const key = $this.data('hover-button');

        const $buttons = $container.find(`[data-hover-ns="${ns}"][data-hover-button]`);
        const $blocks = $container.find(`[data-hover-ns="${ns}"][data-hover-block]`);

        const $buttonsOther = $buttons.filter(`:not([data-hover-button="${key}"])`);
        const $blocksOther = $blocks.filter(`:not([data-hover-block="${key}"])`);
        const $buttonsCurrent = $buttons.filter(`[data-hover-button="${key}"]`);
        const $blocksCurrent = $blocks.filter(`[data-hover-block="${key}"]`);

        $buttonsOther.removeClass('is-active');
        $blocksOther.removeClass('is-active');
        $buttonsCurrent.addClass('is-active');
        $blocksCurrent.addClass('is-active');

        $buttonsOther.trigger('hover-off');
        $buttonsCurrent.trigger('hover-on');
    });

    $container.find(`[data-accordion-button]`).on('click', function () {
        const $this = $(this);
        const ns = $this.data('accordion-ns');
        const key = $this.data('accordion-button');

        const $buttons = $container.find(`[data-accordion-ns="${ns}"][data-accordion-button="${key}"]`);
        const $blocks = $container.find(`[data-accordion-ns="${ns}"][data-accordion-block="${key}"]`);

        if ($this.hasClass('is-active')) {
            $buttons.removeClass('is-active');
            $blocks.removeClass('is-active');
        } else {
            $buttons.addClass('is-active');
            $blocks.addClass('is-active');
        }
    });
}



// WEBPACK FOOTER //
// ./src/js/_modules/tabs.js